const { FLAG } = require('base/src/utils/flag');

FLAG.TRANSLATION = true;
FLAG.DRAWER = false;

module.exports = {
  FLAG,
};
